<div class="search-box">
  <input 
    type="text" 
    [placeholder]="placeholder()" 
    (input)="onInput($event)"
    aria-label="Caja de búsqueda">
</div>